import { render } from "./BtnOptionPhoneticConsonant.vue?vue&type=template&id=727d1aad&scoped=true"
import script from "./BtnOptionPhoneticConsonant.vue?vue&type=script&lang=js"
export * from "./BtnOptionPhoneticConsonant.vue?vue&type=script&lang=js"

import "@/css/components/btn-option-phonetic-consonant.css?vue&type=style&index=0&id=727d1aad&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-727d1aad"]])

export default __exports__